import React from 'react';

const TrainingServices = () => {
  return (
    <>
      <div
        className="breadcumb-wrapper"
        style={{ backgroundImage: "url('assets/img/bg/breadcumb-bg.jpg')" }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Training</h1>
            <ul className="breadcumb-menu">
              <li><a href="home-company.html">Home</a></li>
              <li>Training</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="space-top space-extra-bottom">
        <div className="container">
          <div className="row">
            <div className="col-xl-10 col-xxl-12">
              <div className="title-area text-center">
                <h2 className="sec-title">Services and Expertise Offerred, Training and Awareness Programmes</h2>
                <span className="sub-title">Company SHEQ Policies | Training for all SHEQ Requirements | Awareness Programmes | Risk Management</span>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-10 col-xxl-12">
              <div className="accordion-area accordion mb-30" id="faqAccordion">

                <div className="accordion-card style2 active">
                  <div className="accordion-header" id="collapse-item-1">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-1"
                      aria-expanded="true"
                      aria-controls="collapse-1"
                    >
                      OHSAS 18001: 2001 Occupational Health & Safety Management Systems
                    </button>
                  </div>
                  <div
                    id="collapse-1"
                    className="accordion-collapse collapse show"
                    aria-labelledby="collapse-item-1"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body style2">
                      <p className="faq-text">
                        As the term "Occupational Health and Safety” implies, there are two aspects to this field. One is the area of safety, which seeks to make workplaces safe for workers so that they do not suffer injuries. Poorly designed /maintained workplaces or equipment may pose serious hazards to workers and more than 400,000 injuries occur at work each year. Separate from the concept of safety is that of occupational health, where the goal is to prevent the occurrence of illnesses among workers due to exposure at their place of work. The importance of “Health” in the workplace has now been given greater emphasis under these requirements, so do many other aspects that you may not be aware of. We will bring you up to speed with the NEW requirements, and go beyond that, by implementing this within your company.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="accordion-card style2">
                  <div className="accordion-header" id="collapse-item-2">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-2"
                      aria-expanded="false"
                      aria-controls="collapse-2"
                    >
                      ISO 14001: 2004 environmental Management Systems
                    </button>
                  </div>
                  <div
                    id="collapse-2"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-2"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body style2">
                      <p className="faq-text">
                        It’s been said that internationally, the ISO 14001 standard has already generated interest that far surpasses that of any previous ISO standards, including ISO 9001:2008. Due to the recent introduction of ISO 14001, the implication of this standard on industry, particularly in South Africa, is massive. We will explore the potential benefits and costs (both monetary and environmental) of your Company’s’ involvement in the implementation of ISO 14001. We will be in a position to assist industry and those involved in environmental and trade issues to decide to take ISO 14001 as a credible and useful standard for effective environmental management in South Africa. ISO 14001: 2004 international Standard is generic and flexible enough to apply to any organization. We will apply all the requirements as per Standard, from Scope to Management Review. For your benefit, we will introduce/initiate Audits into your Organisation.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="accordion-card style2">
                  <div className="accordion-header" id="collapse-item-3">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-3"
                      aria-expanded="false"
                      aria-controls="collapse-3"
                    >
                      ISO 9001:2008 - Quality
                    </button>
                  </div>
                  <div
                    id="collapse-3"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-3"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body style2">
                      <p className="faq-text">
                        This is a broad and generic system which could be used by any type of Company. ISO 9001:2008 is designed as a tool for businesses to become more efficient, improve their processes and ultimately their quality. We will simplify the processes, and help you to never lose sight of this basic goal. The ISO 9001:2008 standard is intended for use in any organization which designs, develops, manufactures, installs and/or services any product or provides any form of service. ISO 9001:2008 provides a number of requirements which an organization needs to fulfil if it is to achieve customer satisfaction through consistent products and services which meet customer expectations. ISO 9001:2008 is the only standard for which third-party auditors may grant certifications. We will get you there.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="accordion-card style2">
                  <div className="accordion-header" id="collapse-item-4">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-4"
                      aria-expanded="false"
                      aria-controls="collapse-4"
                    >
                      ISO TS 16949
                    </button>
                  </div>
                  <div
                    id="collapse-4"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-4"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body style2">
                      <p className="faq-text">
                        This International Standard is applicable to all organizations in the automotive industry, either assembling vehicles or in the automotive component manufacture industry.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="accordion-card style2">
                  <div className="accordion-header" id="collapse-item-5">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-5"
                      aria-expanded="false"
                      aria-controls="collapse-5"
                    >
                      SANS 17025: 2005 General requirements for the competence of testing and calibration laboratories
                    </button>
                  </div>
                  <div
                    id="collapse-5"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-5"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body style2">
                      <p className="faq-text">
                        This International Standard is applicable to all organizations performing tests and/or calibrations. These include, third-party laboratories, and laboratories where testing and/or calibration forms part of inspection and product certification.
                        </p>
                    </div>
                  </div>
                </div>

                <div className="accordion-card style2">
                  <div className="accordion-header" id="collapse-item-6">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapse-6"
                      aria-expanded="false"
                      aria-controls="collapse-6"
                    >
                      Training for all SHEQ Requirements
                    </button>
                  </div>
                  <div
                    id="collapse-6"
                    className="accordion-collapse collapse"
                    aria-labelledby="collapse-item-6"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body style2">
                      <p className="faq-text">
                        For each Standard, we develop and provide relevant training to all levels of the organization, such that we make certain that the entire spectrum of the staff is well versed with that Standard.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">


          <div className="page-content style2 mb-40" >
            <h3 className="page-title text-center">Some of Our Popular Training Offerings:</h3>
            <br/>
            <h5 className="page-title">Introduction to Quality Management Systems (QMS) (1 Day)</h5>
            <p className="mb-4 pb-2">
              This course is directed to assist organisations to comply with the ISO 9001:2008 requirements. Ensuring that delegates attending the Course understand and more importantly are able to implement these in their own workplace. It also highlights the importance of personnel roles in their organisations and how to assist them to achieve and exceed customer satisfaction.
            </p>

            <h5 className="page-title">OHSAS 18001: 2007 Occupational Health & Safety Management Systems (3 Days)</h5>
            <p className="mb-4 pb-2">
              Organisations have a legal and social responsibility regarding the occupational health and safety of all employees in their working environment. This requires sound occupational health and safety management systems (OHSMS) due to the hazards and risks that contributes to the detrimental effect on employees. OHSAS18001:2007 has been simplified such, that it is applicable to all types and sizes of organisations. The overall objective of the standard is to enable organisations to identify, eliminate or at least minimise and control their occupational hazards and lower their risks through improvement of OHSMS performance.
            </p>
            <br/>
            <h5 className="page-title">hazard Identification and Risk Assessment (HIRA) (2 Days)</h5>
            <p>ALL personnel responsible for conducting risk assessments within the organization, will benefit from attending. This enhances: -</p>
              <div className="checklist style4 mt-n2">
                <ul>
                  <li>The understanding of the risk assessment process to ensure it is suitable and sufficient</li>
                  <li>Applicable risk assessment principles and formats</li>
                  <li>Recording and reporting of risk assessments and</li>
                  <li>Developing required action plans to ensure continuous risk control</li>
                </ul>
              </div>
              <br />
            <h5 className="page-title">Safety, Health & Environment (SHE) Representative Training (2 Days)</h5>
            <p className="sec-text mb-25">
             Organisations have a legal and social responsibility regarding the occupational health and safety of all employees in their working environment. This requires sound occupational health and safety .This course focuses on the duties, responsibilities, roles and functions of SHE representatives.
             </p>
          </div>
        </div>
        </div>
      </div>

    </>
  );
}

export default TrainingServices;
